<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path fill-rule="evenodd" d="M21.266 17.823c3.065-1.6 4.576-4.133 4.446-7.2-.302-5.91-5.611-7.777-8.33-7.955-.087 0-7.339-.355-8.461 7.822v5.022h2.503v-4.755c.777-5.556 5.267-5.511 5.785-5.511.215 0 5.74.4 6 5.466.086 2.089-.907 3.644-3.065 4.8-1.166.622-2.504.933-3.885.933H4v2.578h12.259c1.77 0 3.496-.4 5.007-1.2zM28 28.178l-1.165-7.6-7.468 1.2 3.28 2.445c-.604.622-2.59 2.533-5.309 2.533-5.395-.133-5.913-4.844-5.957-5.466v-1.556H8.879v1.645c0 .089.475 7.732 8.417 7.955 4.187 0 6.95-3.067 7.381-3.6L28 28.178z" clip-rule="evenodd"/></svg>
</template>

<script>
export default {
  name: 'brandEtus'
}
</script>
